import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-images.css';

var getClassNameList = classNames.bind(styles);
var UitkImageLink = function (_a) {
    var children = _a.children;
    var childrenArray = React.Children.toArray(children).filter(function (child) { return React.isValidElement(child); });
    if (childrenArray.length === 0) {
        return null;
    }
    var firstChild = childrenArray[0];
    var className = firstChild.props.className;
    var classList = getClassNameList('uitk-image-link', className);
    var clonedElement = React.cloneElement(firstChild, {
        className: classList
    }, React.createElement("span", { className: "is-visually-hidden" }, firstChild.props.children));
    return clonedElement;
};
UitkImageLink.displayName = 'UitkImageLink';

export { UitkImageLink };
